import React from "react";
import PropTypes from "prop-types";
import { getCheckoutDisabledMessage } from "utils/stripe";
import StripeConnectActions from "components/StripeConnectActions";

const DEFAULT_CLASSES = {
  container:
    "w-100 flex flex-column flex-row-ns justify-between pv3 items-center-ns",
  contentWrapper: "flex flex-column pr2",
  copy: "f6 fw5 lh-copy pr2",
  description: "f6 lh-copy pr2",
  actionWrapper: "flex flex-shrink-0",
  action: "flex justify-end w-100 pt2 pt0-ns"
};

const StripeConnectBanner = ({
  status,
  chargesEnabled,
  detailsSubmitted,
  authAction,
  customClasses,
  description
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const { copy } = getCheckoutDisabledMessage({
    chargesEnabled,
    detailsSubmitted,
    status
  });
  let action = authAction ? <StripeConnectActions /> : null;

  return action ? (
    <div className={classes.container}>
      <div className={classes.contentWrapper}>
        <div className={classes.copy}>{copy}</div>
        <div className={classes.description}>{description}</div>
      </div>
      <div className={classes.actionWrapper}>
        <div className={classes.action}>{action}</div>
      </div>
    </div>
  ) : null;
};

StripeConnectBanner.propTypes = {
  serviceUid: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired
};

export default StripeConnectBanner;
